import React from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { SimButton } from 'components/SimButton';
import { SimTypography } from 'components/SimTypography';

const Newsletter = () => {
	return (
		<Box>
			<Box marginBottom={4}>
				<SimTypography fontWeight={700} variant={'h4'} align={'center'} gutterBottom>
					Get latest jobs with us posted directly to your inbox, weekly.
				</SimTypography>
			</Box>
			<Box maxWidth={600} margin={'0 auto'}>
				<Box
					component={'form'}
					noValidate
					autoComplete='off'
					sx={{
						'& .MuiInputBase-input.MuiOutlinedInput-input': {
							bgcolor: 'background.default'
						}
					}}>
					<Box
						display='flex'
						flexDirection={{ xs: 'column', md: 'row' }}
						alignItems={{ xs: 'center', md: 'flex-start' }}
						justifyContent={{ xs: 'center' }}>
						<Box
							flex={'1 1 auto'}
							component={TextField}
							label='Enter your email'
							variant='outlined'
							color='primary'
							fullWidth
							height={54}
							sx={{
								maxWidth: 422
							}}
						/>
						<Box
							component={SimButton}
							variant='contained'
							color='primary'
							size='large'
							height={54}
							marginTop={{ xs: 2, md: 0 }}
							marginLeft={{ md: 2 }}>
							Subscribe
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export default Newsletter;
